import { useCallback, useEffect, useRef, useState } from 'react';
import './CommonChats.scss';
import CommonChatBox from './components/CommonChatBox';
import CommonChatList from './components/CommonChatList';
import { useLazyQuery } from '@apollo/client';
import { GET_ALL_GROUP_CHAT_LIST, GET_ALL_CHAT_LIST } from './api/ChatsQuery';
import ToasterWithMessage from '../../components/toaster';
import { FETCH_POLICY_NO_CACHE, PATH_ADDRESSES, STUDENT_ROLE, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, SUBJECT_NOT_FOUND_ERROR, VIRTUAL } from '../../utils/constants';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../redux/app/hooks';
import { InitialiseChatConnection } from '../../websocket/ChatWebSocket';
import Loader from '../../components/Loader/Loader';
import ImageViewer from '../../components/ImageViewer/ImageViewer';
import images from '../../assets/images';
import VideoViewer from '../../components/VideoViewer/VideoViewer';
import PDFViewer from '../../components/PDFViewer/PDFViewer';
import CsvViewer from '../../components/CsvViewer/CsvViewer';
import FileViewer from '../../components/FileViewer/FileViewer';
import { useDispatch } from 'react-redux';
import { logout, setAdminId, setAdminProfile, setAdminProfileImage, setIsNotificationEnable, setSchoolType } from '../../redux/slices/authSlice';
import EpubFileViewer from '../../components/EpubFileViewer/EpubFileViewer';
import { GET_CURRENT_USER } from '../AdminDashboard/api/AdminDashboardQuery';
import { visibility } from '../../redux/slices/rightSideAd';
import { getScreenDimensions } from '../../utils/helper';

export interface SelectedChat{
  chatId: string;
  chatType: chatType[keyof chatType],
  chatroomId: string;
  chatroomName: string;
}

export interface ChatListType{
    chatId: string;
    chatType: chatType[keyof chatType],
    chatroomId: string;
    chatroomName: string;
    chimeChannelArn: string | null;
}
export interface AllChatListType {
  nodes: ChatListType[]
}

export type chatType = {
  SCHOOL : "SCHOOL",
  TEACHERS: "TEACHERS",
  OneToOne: 'OneToOne'
}
export interface CombinedMessages{
  content:string;
  type:string;
}

export interface SingleChatType{
  toUserId?: string,
  "deletedAt"?: string,
  "deletedForEveryOne":string|null,
  "deletedForMe":string|null,
  isMessageEdited: boolean;
  "msgType": string,
  "chatRoomId": string,
  "combinedMessage":CombinedMessages[],
  "fileinfo":{
    "filename":string;
    "filetype":string;
    "filesize":number;
    }
  "userId": string,
  "updatedAt": string,
  "userAvatarUrl"?: string,
  "userName": string,
  "createdAt": string,
  "message": string,
  "id": string,
  "replyId": string,
  "replyData":SingleChatType,
  "isReadBy": [
      {
          "userName": string,
          "userId": string
      }
  ],
  "toUserName": string
}
export interface ChatdataType{
  chatData: SingleChatType[],
  totalCount: number
}
export interface SearchUserType{
  uFullName:string;
    uRole: string;
    uEmailId:string;
    uId:string;
    teachersByUId:{
      nodes:{
        tAvatarUrl:string;
        tId:string;
        tName:string;
        teacherClassroomsByTId:{
          nodes:{
            cId:string;
          }
        }
      }[]
    }
    studentsByUId:{
      nodes:{
        sAvatarUrl:string;
        sId:string;
        uId:string;
        studentClassroomsBySId:{
          nodes:{
            cId:string;
          }
        }
      }[]
    }
}
export interface UserList{
  nodes:SearchUserType[]
}

export interface DefaultUserType{
    chatId:string;
    from:{
      uFullName: string;
      uId: string;
      uPhoneNumber: string;
      uRole: string;
      teachersByUId:{
        nodes:{
          tAvatarUrl: string;
        }[]
      }
      studentsByUId:{
        nodes:{
          sAvatarUrl:string;
        }[]
      }
    };
    to:{
      uFullName:string;
      uId: string;
      uPhoneNumber: string;
      uRole: string;
      uChatActive: boolean;
      teachersByUId:{
        nodes:{
          tAvatarUrl: string;
        }[]
      }
      studentsByUId:{
        nodes:{
          sAvatarUrl:string;
        }[]
      }
    };
    chatroomId:string;
    chatType:string;
    unReadMessagesCount:number;
    chimeChannelArn: string | null;
}
export interface DefaultUserList{
  nodes: DefaultUserType[];
  totalCount:number;
}

export interface TypingUserType{
  chatRoomId?:string;
  channelArn?:string;
  fromUserId?:string;
  fromUserArn?:string;
  fromUserName:string;
  type:string;
}

const CommonChats = () => {
  const [selectedChat, setSelectedChat] = useState<DefaultUserType>();
  const [selectedGroupChat, setSelectedGroupChat] = useState<ChatListType>();
  const [selectedSearchChat, setSelectedSearchChat] = useState<SearchUserType>();
  const [chatSearchList, setChatSearchList] = useState<ChatListType[]>();
  const [chatGroupList, setChatGroupList] = useState<ChatListType[]>();
  const [chatList, setChatList] = useState<DefaultUserList>();
  const [chatMessages, setChatMessages] = useState<ChatdataType>();
  const [unreadMessageIds, setUnreadMessageIds] = useState<string[]>([]);
  const [hasMore, setHasMore] = useState(false);
  const { error } = ToasterWithMessage();
  const socketRef = useRef<WebSocket | null>(null);
  const role = useAppSelector((state) => state.auth.role);
  const navigate = useNavigate();
  const profile = useAppSelector((state) => state?.auth?.adminProfile);
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  const selectedSubjectId = localStorage.getItem('selectedSId');
  const schoolType = useAppSelector((state) => state.auth.schoolType);
  const [refetch,setRefetch] = useState(false);
  const [type,setType] = useState('');
  const pingIntervalRef = useRef<number | null>(null);
  const [socketReadyState,setSocketReadyState] = useState<number>(0);
  const [chatLoading,setChatLoading] = useState<boolean>(true);
  const [typing,setTyping] = useState<boolean>(false);
  const [typingUsers,setTypingUsers] = useState<TypingUserType[]>([]);
  const [viewerUrl,setViewerUrl] = useState<string>('');
  const [viewType,setViewType] = useState<string>('');
  const baseUrl = process.env.REACT_APP_FRONTEND_URL;
  const { backArrow, schoolProfileImage } = images;
  const dispatch = useDispatch();  
  const loginpage = useAppSelector((state) => state.auth.loginpage);
  const { isMobileScreen } = getScreenDimensions();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const studentClasscode: string |null = localStorage.getItem('studentClassCode')
  const chatService = process.env.REACT_APP_COMMON_CHAT_SERVICE || 'WEBSOCKET';
  const isChime = chatService === 'CHIME';


  const InitialiseChatting = () => {
    if (!isChime) {
      console.log("Initializing the socket connection");
      socketRef.current = InitialiseChatConnection();
      console.log('socketRef----',socketRef?.current?.readyState)
      // socketRef.current.onopen = () => {
      // }
    }
  }

const [getGroupChatList, { loading }] = useLazyQuery(GET_ALL_GROUP_CHAT_LIST, {
  fetchPolicy: FETCH_POLICY_NO_CACHE,
  onCompleted: (data) => {
    setChatGroupList(data?.getChats);
    setSelectedGroupChat(data?.getChats?.[0]);
    setSelectedChat(undefined);
    setSelectedSearchChat(undefined);
    setType('group');
  },
  onError: (err) => {
    if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
      setTimeout(() => {
        if (role === STUDENT_ROLE) {
          navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
        } else {
          navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
        }
      }, 2000);
    }
  }
});

const [getChatList] = useLazyQuery(GET_ALL_CHAT_LIST, {
  fetchPolicy: FETCH_POLICY_NO_CACHE,
  onCompleted: (data) => {
    setChatSearchList(undefined);
    setChatList(data?.getIndividualChatList);
  },
  onError: (err) => {
    if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
      setTimeout(() => {
        if (role === STUDENT_ROLE) {
          navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
        } else {
          navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
        }
      }, 2000);
    }
  }
});

  const [getCurrentUser, { loading: currentuserloading }] = useLazyQuery(GET_CURRENT_USER,{
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      if(data && data?.getCurrentUser){
        const AdminRole =(data?.getCurrentUser?.nodes[0]?.uRole)?.toLowerCase();
        if(AdminRole === loginpage){
          if(loginpage === 'schooladmin'){
            dispatch(setAdminProfile({profile: data}));
            dispatch(setAdminId(data?.getCurrentUser?.nodes[0]?.schoolAdminsByUId?.nodes[0]?.saId))
            dispatch(setIsNotificationEnable(data?.getCurrentUser?.nodes[0]?.schoolAdminsByUId?.nodes[0]?.saNotificationEnabled))
            dispatch(setAdminProfileImage({ adminProfileImage: data?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saAvatarUrl : schoolProfileImage }))
            dispatch(setSchoolType({schoolType: data?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.adminType}));
          }else if(loginpage === 'teacher'){
            dispatch(setAdminProfile({profile: data}));
            dispatch(visibility({isVisible: false}));
            dispatch(setAdminProfileImage({ adminProfileImage: data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl : schoolProfileImage }))
            dispatch(setSchoolType({schoolType: data?.schoolAdmin?.nodes?.[0]?.adminType}));
          }else if(loginpage === 'student'){
            dispatch(setAdminProfile({profile: data}));
            dispatch(visibility({isVisible: false}));
            dispatch(setAdminProfileImage({ adminProfileImage: data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl : schoolProfileImage }))
            dispatch(setSchoolType({schoolType: data?.schoolAdmin?.nodes?.[0]?.adminType}));
          }
        }else{
          dispatch(logout());
        }
      }else {
        error("User Not Found!");
      }
    },
    onError: (err) => {
      error(err?.message);
      dispatch(logout());
    }
  });

const pingFunction = () =>{
  if (!isChime) {
    // Send a ping every 30 seconds to keep connection alive
    pingIntervalRef.current = window.setInterval(() => {
      if (socketRef?.current) {
        setSocketReadyState(socketRef?.current?.readyState);
      console.log('interval check---',socketRef?.current?.readyState);
      }
      if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
        socketRef.current.send(JSON.stringify({ type: 'ping' }));
      }
    }, 1000); // Adjust the interval as needed
  }
}

useEffect(() => {
  if (!isChime) {
    InitialiseChatting();
    
    // Start the ping function
    pingFunction();
  }
  // dispatch(setRefetchCurrentUser({ refetchCurrentUser: true }));
  if(role === STUDENT_ROLE){
        getCurrentUser({
          variables : {
            classCode : studentClasscode
          }
        })
      }
    else {
      getCurrentUser({
        variables : {
            classCode : ""
          }
      });
    }

  // Cleanup function to clear the interval and close the socket on unmount
  return () => {
    if (pingIntervalRef.current !== null) {
      clearInterval(pingIntervalRef.current);
      pingIntervalRef.current = null; // Reset the reference
    }
    if (socketRef.current) {
      socketRef.current.close();
      socketRef.current = null; // Reset the reference
    }
  };
}, []);

useEffect(()=>{
   if (!isChime) {
     if(socketReadyState === 0){
      pingFunction();
     }else if(socketReadyState === 3){
      const timer = setTimeout(() => {
        if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
          console.log("Reconnecting the socket");
          InitialiseChatting();
        }
      }, 2000);
      return () => clearTimeout(timer);
     }
   }
},[socketReadyState, isChime]);

const handleChimeTyping = (content: any) => {
  const typingData = {
    type: "typing",
    channelArn: content.channelArn,
    fromUserArn: content.userArn,
    fromUserName: content.userName,
  };

  setTyping(true);

  setTimeout(() => {
    setTypingUsers((prevUsers) =>
      prevUsers.filter(
        (user) => !(user.channelArn === typingData.channelArn && user.fromUserArn === typingData.fromUserArn)
      )
    );
    setTyping(false);
  }, 2000);

  setTypingUsers((prevUsers) => {
    const userExists = prevUsers.some(
      (user) => user.channelArn === typingData.channelArn && user.fromUserArn === typingData.fromUserArn
    );

    if (!userExists) {
      return [...prevUsers, typingData];
    }
    return prevUsers;
  });
};

useEffect(() => {
  console.log('inside the useEffect----', socketRef?.current?.readyState)
  if(!isChime && (socketRef.current && socketRef.current !== null) && socketRef?.current?.readyState === 1) {
    // setChatMessages(undefined);
    console.log('outside the data hit to websocket','selectedChat--',selectedChat,'selectedGroupChat',selectedGroupChat)
    socketRef.current.onmessage = (event: any) => {
      const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      console.log('Data----', data)
      switch (data.type) {
        case "getChatMessages":
          if(data?.response?.status === 200){
            setHasMore(false);
            const spaceChatsResult = data.response.chats ?? {};
            const nodes = spaceChatsResult.chatData ?? [];
            console.log("[Debug] existing messages", nodes);
            setChatMessages((prev) => {
              // Combine existing chatData with new nodes
              const updatedChatData = prev?.chatData ? [...prev.chatData, ...nodes] : [...nodes]; 
              // Calculate the total count or use a default of 0
              const totalCount = spaceChatsResult?.totalCount ?? 0;
              // Update hasMore state
              setHasMore(nodes.length > 0 && updatedChatData.length < totalCount); // Ensure hasMore is updated correctly
              // Return an object matching chatdataType, ensuring totalCount is a number
              return {
                // ...prev,
                chatData: updatedChatData,
                totalCount: totalCount,
              };
          });
          
            // console.log(data.response.chats.chatData);
            const currentUserId = profile?.getCurrentUser?.nodes?.[0]?.uId;

            // Extract unread messages
            const newUnreadMessageIds: string[] = data.response.chats.chatData
              .filter((message:SingleChatType) => 
                !message.isReadBy.some((reader:any) => reader.userId === currentUserId)
              )
              .map((message:SingleChatType) => message.id);

            setUnreadMessageIds(newUnreadMessageIds);
            setChatLoading(false);
            setTimeout(() => {
                getChatList({
                  variables: {
                    input: {
                      cId: selectedClassRoomId,
                      sjId: selectedSubjectId,
                      // uId:profile?.getCurrentUser?.nodes?.[0]?.uId,
                      limit: null,
                      offset: null
                    }
                  }
                });
            }, 2000);
          }
          break;
        case "newMessageAdded":
          const currentUserId = profile?.getCurrentUser?.nodes?.[0]?.uId;
          const newChatData = data.data || {};
          const newMessageChatRoomId = newChatData.chatRoomId;
          if(newChatData?.toUserId === currentUserId){
            setTimeout(() => {
                getChatList({
                  variables: {
                    input: {
                      cId: selectedClassRoomId,
                      sjId: selectedSubjectId,
                      // uId:profile?.getCurrentUser?.nodes?.[0]?.uId,
                      limit: null,
                      offset: null
                    }
                  }
                });
            }, 2000);
          }
          if((selectedChat?.chatroomId || selectedGroupChat?.chatroomId ) === newMessageChatRoomId) {
            console.log('newchatdata--------->',newChatData);
            setChatMessages((prev) => {
              const prevChatData = prev?.chatData || [];
  
              const updatedChatData = [newChatData,...prevChatData];
              console.log('updatedChatData------->',updatedChatData)
              return {
                // ...prev,
                chatData: updatedChatData,
                totalCount: updatedChatData.length
              };
            });
          }

          // Update unread message IDs
          setUnreadMessageIds((prevUnreadIds) => {
            const newUnreadMessageIds = (data.data.chatData || [])
              .filter((message: SingleChatType) =>
                !message.isReadBy.some((reader: any) => reader.userId === currentUserId)
              )
              .map((message: SingleChatType) => message.id);

            // Combine new unread messages with previous unread messages
            return [...(prevUnreadIds || []), ...newUnreadMessageIds];
          });
          setChatLoading(false);
          console.log('newMessageAdded', data.data);

            break;   
          case "editMessage":
          case "deletedMessage":
            const deletedChatData = data.data || {};
            const deletedMessageChatRoomId = deletedChatData.chatRoomId;
          
            if ((selectedChat?.chatroomId || selectedGroupChat?.chatroomId) === deletedMessageChatRoomId) {
              console.log('deletedChatData--------->', deletedChatData);
              
              setChatMessages((prev) => {
                const prevChatData = prev?.chatData || [];
                
                // Replace the entire message where the ID matches
                const updatedChatData = prevChatData.map((message) => {
                  if (message.id === deletedChatData.id) {
                    return {
                      ...deletedChatData,  // Replace all fields with new data from deletedChatData
                    };
                  }
                  return message;  // Return unchanged message if no match
                });
          
                console.log('updateddeleteChatData------->', updatedChatData);
          
                return {
                  chatData: updatedChatData,
                  totalCount: updatedChatData.length,
                };
              });
            }
          
            // Update unread message IDs
            setUnreadMessageIds((prevUnreadIds) => {
              const newUnreadMessageIds = (data.data.chatData || [])
                .filter((message: SingleChatType) =>
                  !message.isReadBy.some((reader: any) => reader.userId === currentUserId)
                )
                .map((message: SingleChatType) => message.id);
          
              // Combine new unread messages with previous unread messages
              return [...(prevUnreadIds || []), ...newUnreadMessageIds];
            });
          
            setChatLoading(false);
            console.log('newdeletedMessageAdded', data.data);
          
            break;          
        case "typing": 
          console.log('inside typing case')
          setTyping(true);
          setTimeout(() => {
              setTypingUsers((prevUsers) =>
                prevUsers?.filter(
                  (user:any) => !(user.chatRoomId === data?.chatRoomId && user.fromUserId === data?.fromUserId)
                )
              );
              setTyping(false)
          }, 3000);
          // setTypingUsers(data)
          setTypingUsers((prevUsers) => {
            // Check if the user already exists in the state
            const userExists = prevUsers?.some(
              (user:any) =>
                user.chatRoomId === data?.chatRoomId &&
                user.fromUserId === data?.fromUserId
            );
      
            // If user does not exist, add to state
            if (!userExists) {
              console.log('Inside userExist')
              return [...prevUsers, data];
            }
            // If user already exists, return previous state unchanged
            return prevUsers;
          });
          break;
        default:
          setChatLoading(false);
          break;
      }
    }
    if((selectedChat || selectedGroupChat) && socketRef?.current?.readyState === 1){
      console.log('inside the data hit to websocket','selectedChat--',selectedChat,'selectedGroupChat',selectedGroupChat)
      setChatMessages(undefined);
      setChatLoading(true);
      const messageData = {
        "type": "getAllMessagesByChatRoomId",
        "data": {
            "chatRoomId": selectedChat?.chatroomId || selectedGroupChat?.chatroomId,
            "exclusiveStartKey": '',
            "limit": 10
        }
    }
    socketRef.current.onerror = (event) => {
      console.log('ONERROR', event)
    }
    try{
      socketRef.current.send(JSON.stringify(messageData));
    }catch(err){
      console.log('err in socket-----',err)
    }
    }
  }
}, [selectedChat?.chatroomId,selectedGroupChat?.chatroomId,selectedSearchChat, socketRef.current?.readyState, isChime])

  useEffect(()=>{
    if(profile){
    getGroupChatList({
      variables: {
        input: {
          messagingProvider: isChime ? 'CHIME' : 'WEBSOCKET',
          ...(schoolType === VIRTUAL && {
            cId: selectedClassRoomId,
            sjId: selectedSubjectId,
          }),
        }
      }
    });
    getChatList({
      variables:{
        input:{
          cId:selectedClassRoomId,
          sjId:selectedSubjectId,
          messagingProvider: isChime ? 'CHIME' : 'WEBSOCKET',
          // uId:profile?.getCurrentUser?.nodes?.[0]?.uId,
          limit:null,
          offset:null
        }
      }
    });
  }
  },[profile, schoolType, selectedClassRoomId, selectedSubjectId]);

  const loadMore = useCallback(() => {
    if (isChime) {
      return; // Chime pagination handled in CommonChatBox
    }
    console.log('Inside loadmore useCallback',hasMore);
    if (hasMore  === false) {
      return;
    }
    if(socketRef.current) {
      const messageData = {
        "type": "getAllMessagesByChatRoomId",
        "data": {
            "chatRoomId": selectedChat?.chatroomId || selectedGroupChat?.chatroomId,
            "exclusiveStartKey": chatMessages?.chatData[chatMessages?.chatData?.length - 1]?.createdAt,
            "limit": 10
        }
      }
      console.log('pagination data for chat',messageData);
      if (socketRef.current && socketRef?.current?.readyState === 1) {
        socketRef.current.send(JSON.stringify(messageData));
      }
    }
  }, [hasMore, chatMessages, selectedChat, selectedGroupChat, isChime]);


  const handleCloseViewer = () =>{
    setViewType('');
    setViewerUrl('');
  }

  console.log('chatMessages in parent------------->',chatMessages);
  
  return (
    <div className='commonChatsMainContainer'>
      {(loading) ? (
          <Loader bottom="110px" />
        ) : (viewType === 'ImageViewer' && viewerUrl) ? (
            <div className='ViewerCtn'>
              <img className='ViewerBackBtn' onClick={handleCloseViewer} alt="back-arrow" src={backArrow} />
              <div className='viewerBodyCtn'>
                <ImageViewer
                  file={baseUrl+viewerUrl}
                  imgFileData={undefined}
                  onClose={handleCloseViewer}
                  type="chat"
                />
              </div>
            </div>
        ) : (viewType === 'VideoViewer' && viewerUrl) ? (
            <div className='VideoViewerCtn'>
              <img className='VideoViewerBackBtn' onClick={handleCloseViewer} alt="back-arrow" src={backArrow}/>
              <div className='viewerBodyCtn'>
                <VideoViewer
                  video={baseUrl+viewerUrl}
                  onClose={handleCloseViewer}
                  type={"chat"}
                  videoData={undefined}
                />
              </div>
            </div>
        ) : ((viewType === 'PdfViewer' || viewType ==='ExcelViewer' || viewType === 'DocViewer' || viewType === 'PptViewer' || viewType === 'CsvViewer' ||  viewType === 'epubViewer') && viewerUrl ) ? (
            <div className='ViewerCtn'>
              <img className='ViewerBackBtn' onClick={handleCloseViewer} alt="back-arrow" src={backArrow}/>
              <div className='viewerBodyCtn'>
                {( viewType === 'PdfViewer' ) ? (
                    <PDFViewer 
                      file={baseUrl + viewerUrl}
                      pdfFileData={undefined}
                      onClose={handleCloseViewer}
                      type={"chat"}
                    />
                  ) : (viewType ==='ExcelViewer' || viewType === 'DocViewer' || viewType === 'PptViewer' ) ? ( 
                    <FileViewer
                      fileUrl={baseUrl + viewerUrl}
                      fileData={undefined}
                      onClose={handleCloseViewer}
                      type={"chat"}
                      fileType={viewType ==='ExcelViewer' ? 'excel' : viewType === 'DocViewer' ? "doc" : "ppt"}
                    />
                  ) : (viewType === 'CsvViewer') ? ( 
                    <CsvViewer
                      fileUrl={baseUrl + viewerUrl}
                      fileData={undefined}
                      onClose={handleCloseViewer}
                      type={"chat"}
                    />
                  )  : (viewType === 'epubViewer') ? (
                    <EpubFileViewer
                      fileUrl={baseUrl + viewerUrl}
                      fileData={undefined}
                    />
                  ) : <></>
                }
              </div>
            </div>
        ) : (
        <>
          {((isMobileScreen && isSidebarOpen ) || !isMobileScreen) && 
            <CommonChatList 
            setSelectedChat={setSelectedChat} 
            selectedChat={selectedChat} 
            setSelectedGroupChat={setSelectedGroupChat} 
            selectedGroupChat={selectedGroupChat} 
            setSelectedSearchChat={setSelectedSearchChat} 
            selectedSearchChat={selectedSearchChat} 
            chatList={chatList} 
            socketRef={socketRef} 
            chatGroupList={chatGroupList} 
            setRefetch={setRefetch} 
            setChatList={setChatList} 
            setType={setType} 
            type={type} 
            setChatMessages={setChatMessages} 
            chatMessages={chatMessages} 
            chatLoading={chatLoading} 
            setChatLoading={setChatLoading} 
            isSidebarOpen={isSidebarOpen} 
            setIsSidebarOpen = {setIsSidebarOpen} 
            isChime={isChime} 
            />
          }
          {((isMobileScreen && !isSidebarOpen) || !isMobileScreen) && 
            <CommonChatBox 
              selectedChat={selectedChat} 
              selectedSearchChat={selectedSearchChat} 
              selectedGroupChat={selectedGroupChat}  
              loadMore={loadMore} 
              hasMore={hasMore} 
              socketRef={socketRef} 
              chatMessages={chatMessages} 
              setType={setType} 
              type={type} 
              chatLoading = {chatLoading} 
              typingUsers={typingUsers} 
              setViewType={setViewType} 
              setViewUrl={setViewerUrl} 
              isSidebarOpen={isSidebarOpen} 
              setIsSidebarOpen = {setIsSidebarOpen} 
              isChime={isChime} 
              chimeChannelArn={selectedGroupChat?.chimeChannelArn || selectedChat?.chimeChannelArn || null} 
              handleChimeTyping={handleChimeTyping} 
              getChatList = {getChatList} 
            />
          }
        </>
        )
      }
    </div>
  )
}

export default CommonChats;
